<template>
    <div class="login-page flex align-center" :style="{'height': clientHeight + 'px'}">
        <div class="login-bg flex">
            <div class="position">
                <swiper v-if="loginImages.length > 0" :options="swiperLogin" style="width:600px;height: 100%" ref="mySwiper">
                    <swiper-slide
                        v-for="(slide, index) in loginImages"
                        :key="index">
                        <img class="swiper-img" :src="slide.imgPath" :alt="slide.name">
                    </swiper-slide>
                </swiper>
                <div class="swiper-pagination"></div>
            </div>
            <div class="login-contain text-center">
                <img class="logo" src="./../../image/img/logo.png" alt="">
                <p class="font-26 font-thin opacity-5 m-b-40">账号登录</p>
                <el-form :model="form" ref="loginForm" :rules="rules">
                    <el-form-item prop="userName">
                        <el-input
                            class="form-input"
                            name="userName"
                            placeholder="请输入账号"
                            v-model="form.userName"
                            autocomplete="on"
                            clearable>
                            <i slot="prefix" class="el-icon-mobile-phone"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input
                            class="form-input"
                            name="password"
                            placeholder="请输入密码"
                            v-model="form.password"
                            autocomplete="on"
                            show-password>
                            <i slot="prefix" class="el-icon-lock"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="identifyingCode">
                        <el-input
                            class="form-input"
                            placeholder="请输入验证码"
                            clearable
                            maxlength="6"
                            auto-complete="off"
                            v-model="form.identifyingCode">
                            <el-button
                                style="line-height: 1.8;"
                                :disabled="identifyLoading || codeText !== '获取验证码'"
                                :loading="identifyLoading && codeText !== '获取验证码'"
                                @click.stop="getIdentifyingCode()"
                                slot="append">{{codeText}}</el-button>
                        </el-input>
                    </el-form-item>
                </el-form>
                <el-button :loading="submitLoading" @click.stop="submitClick('loginForm')" class="login-btn m-b-10">登录</el-button>
                <br>
                <div class="flex just-between align-center" style="width: 300px; margin: 0 auto;">
                    <div class="font-14 pointer" @click="readInformation">
                        <i v-if="!hasAgree" class="el-icon-success" style="font-size: 16px; margin-right: 5px; color: #a3a3a3;"></i>
                        <i v-else class="el-icon-success" style="font-size: 16px; margin-right: 5px; color: #BC5BA7;"></i>
                        我已阅读<el-button type="text" @click.stop="informationdialog = true">《用户协议》</el-button>
                    </div>
                    <span class="font-14 link-black" type="text" @click="forgetPassword">忘记密码</span>
                </div>
            </div>
        </div>
        <el-dialog
            title="UIOT超级智慧家经销商在线商城声明"
            :visible.sync="informationdialog"
            width="70%"
            center
            :modal-append-to-body="true"
            :close-on-click-modal="false">
            <div class="font-16" style="line-height: 30px;">
                <p style="text-indent: 2rem;">1、本在线商城系版权由超级智慧家（上海）物联网科技有限公司发布并维护，使用本系统前请仔细阅读本声明，使用本在线商城即表示您完全理解本声明的内容并接受本声明所列的条款；若不同意以下条款，请停止使用本系统。</p>
                <p style="text-indent: 2rem;">2、超级智慧家（上海）物联网科技有限公司保留随时对本声明的条款进行修订的权利以及保留任何未在本系统各项条款中明示授予的权利。</p>
                <p style="text-indent: 2rem;">3、为保障各经销商的利益，本在线商城所显示的内容，除超级智慧家（上海）物联网科技有限公司在其官方网站已进行公开的内容外， 其余内容（包括但不限于各产品的经销商供货价格、本信息系统的登录账号及密码）均属于超级智慧家（上海）物联网科技有限公司的商业机密， 使用者必须对该内容进行严格保密，未经超级智慧家（上海）物联网科技有限公司的书面许可，严禁以任何形式复制、传递、公开或泄露该内容。</p>
                <p style="text-indent: 2rem;">4、本在线商城的登录账号及密码是您使用本在线商城的唯一途径，请妥善保管，不得将登录账号及密码提供给非经销商以外的人使用， 若因此造成超级智慧家（上海）物联网科技有限公司商业机密的泄露，该登录账号对应的经销商将对此承担全部责任。</p>
                <p style="text-indent: 2rem;">5、超级智慧家（上海）物联网科技有限公司一经查实本声明第3条所列商业机密的泄密者的，有权立即终止该泄密者使用本在线商城的权限， 并有权立即解除与该泄密者的代理协议且无需承担任何违约责任，并保留追究该泄密者法律责任和经济责任的权利。 若因此造成超级智慧家（上海）物联网科技有限公司商业机密的泄露，该登录账号对应的经销商将对此承担全部责任。</p>
                <p style="text-indent: 2rem;">6、使用者因泄密行为被超级智慧家（上海）物联网科技有限公司终止代理协议由此造成使用者经济损失的，超级智慧家（上海）物联网科技有限公司不负责赔偿。 若因此造成超级智慧家（上海）物联网科技有限公司商业机密的泄露，该登录账号对应的经销商将对此承担全部责任。</p>
                <p style="text-indent: 2rem;">7、严禁使用者利用本在线商城从事非法活动。 若因此造成超级智慧家（上海）物联网科技有限公司商业机密的泄露，该登录账号对应的经销商将对此承担全部责任。</p>
                <p class="text-right">超级智慧家（上海）物联网科技有限公司</p>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import { MessageBox } from 'element-ui'
    export default {
        data() {
            var verifyIdentifyingCode = (rule, value, callback) => {
                var trimValue = value ? value.trim() : ''
                this.form.identifyingCode = trimValue
                if (!this.form.handset) { callback(new Error('请获取验证码')) }
                if (trimValue === '') {
                    callback(new Error('请输入验证码'))
                } else if (this.form.handset) {
                    this.commonAjax({
                        url: `/verifyCodeLog/verifyMsg/${this.form.identifyingCode}/${this.form.handset}`,
                        type: 'GET',
                        success: (res) => {
                            callback()
                        },
                        error: (msg) => {
                            callback(new Error(msg))
                        }
                    })
                }
            }
            return {
                clientHeight: 0,
                submitLoading: false,
                loginImages: [],
                form: {
                    userName: '',
                    password: '',
                    phoneNum: '',
                    identifyingCode: '',
                    handset: '',
                },
                swiperLogin: {
                    autoplay: {
                        delay: 6000,
                        stopOnLastSlide: false,
                        disableOnInteraction: true,
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        bulletClass: 'my-bullet',
                        bulletActiveClass: 'my-bullet-active',
                        clickable: true
                    },
                    initialSlide: 0,
                    setWrapperSize: true,
                    mousewheelControl: false,
                    observer: true,
                    observeParents: true,
                    loopAdditionalSlides: 1
                },
                rules: {
                    userName: [
                        {required: true, message: '请输入账号', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'}
                    ],
                    identifyingCode: [
                        {required: true, validator: verifyIdentifyingCode, trigger: 'blur'}
                    ],
                },
                informationdialog: false,
                hasAgree: false,
                identifyLoading: false,
                timer: null,
                time: 59,
                codeText: '获取验证码',
            }
        },
        activated() {
            this.$nextTick(() => {
                this.$refs.loginForm.resetFields()
                this.form.userName = this.$PcLockr.get('userName') || ''
                this.form.password = this.$PcLockr.get('password') || ''
                this.form.phoneNum = this.$PcLockr.get('login_phoneNum') || ''
                this.$PcLockr.set('userName', '')
                this.$PcLockr.set('password', '')
                this.getLoginImage()
            })
        },
        created: function() {
            if (localStorage.getItem('username')) {
                this.form.userName = localStorage.getItem('username')
            }
        },
        components: {
            swiper,
            swiperSlide
        },
        mounted() {
            this.clientHeight = document.documentElement.clientHeight
            this.hasAgree = this.$PcLockr.get('hasAgree')
        },
        methods: {
            // 同意用户协议
            readInformation() {
                this.hasAgree = !this.hasAgree
                this.$PcLockr.set('hasAgree', this.hasAgree)
            },
            // 获得登录页轮播
            getLoginImage() {
                this.ajax({
                    type: 'POST',
                    url: `/banner/list?applyLocation=1`,
                    success: (data) => {
                        if (data.data.length > 0) {
                            this.loginImages = data.data
                        }
                    },
                })
            },
            // 获取验证码
            getIdentifyingCode() {
                if (!this.form.userName.trim()) {
                    this.$pcMessage.warning({
                        message: '请输入手机号'
                    })
                    return false
                }
                this.identifyLoading = true
                this.time = 59
                this.codeText = `重新获取(${this.time}s)`
                this.timeMath()
                this.commonAjax({
                    url: `/verifyCodeLog/sendMsg/${this.form.userName}`,
                    type: 'GET',
                    success: (res) => {
                        // this.$pcMessage.success('发送成功')
                        let phoneValFormat = res.msg.replace(/^(\d{3})\d*(\d{4})$/, '$1****$2')
                        this.$pcMessage.success(`已发送至 ${phoneValFormat}`)
                        this.form.handset = res.msg
                        this.identifyLoading = false
                    },
                    error: (msg) => {
                        this.closeTimer()
                        MessageBox.alert(msg || '未知错误', '提示', {
                            confirmButtonText: '我知道了',
                            center: true,
                        })
                    },
                    complete: () => {
                        this.identifyLoading = false
                    }
                })
            },
            // 倒计时时间计算
            timeMath() {
                this.timer = setTimeout(() => {
                    this.time--
                    this.codeText = `重新获取(${this.time}s)`
                    if (this.time > 0) {
                        this.timeMath()
                    } else {
                        // 倒计时结束，重置显示
                        this.codeText = '获取验证码'
                        this.time = 59
                    }
                }, 1000)
            },
            // 清空倒计时
            closeTimer() {
                if (this.timer) {
                    clearTimeout(this.timer)
                }
                this.time = 59
                this.codeText = '获取验证码'
            },
            // 登录操作
            submitClick(formName) {
                if (!this.hasAgree) {
                    this.$pcMessage.warning({
                        message: '请先阅读用户协议'
                    })
                    return
                }
                this.$refs[formName].validate((valid) => {
                    // console.log(valid)
                    if (valid) {
                        this.submitLoading = true
                        this.ajax({
                            url: `/userInfo/auth`,
                            type: 'GET',
                            data: this.form,
                            success: (res) => {
                                this.$store.commit('setToken', res.result.token)
                                this.$store.commit('setUserInfo', res.result.user)
                                this.$PcLockr.set('token', res.result.token)
                                this.$PcLockr.set('userInfo', res.result.user)
                                this.$pcBus.$emit('getAllCart')
                                window.location.href = '/index'
                                this.submitLoading = false
                            },
                            error: (error) => {
                                MessageBox.alert(error, '提示', {
                                    confirmButtonText: '我知道了',
                                    center: true,
                                })
                                this.submitLoading = false
                            }
                        })
                    } else {
                        this.$pcMessage.error('请检查录入信息是否正确')
                    }
                })
            },
            // 忘记密码
            forgetPassword() {
                // this.loadPage('forgetPwd')
                window.location.href = '/forgetPwd'
            },
            // 注册
            registAccount() {
                this.loadPage('regist')
            },
            specifiName(username) {
                // console.log(username)
                this.ajax({
                    url: `/userInfo/queryV4Url/${username}`,
                    type: 'GET',
                    success: (res) => {
                        if (res.code === 0) {
                            localStorage.setItem('username', username)
                            // window.location.href = 'https://' + res.data
                            this.$store.commit('setHostCode', res.data)
                        }
                    },
                    error: (error) => {
                        console.log(error)
                    }
                })
            },
        }
    }
</script>
<style>
    .el-input__inner{
        border: 1px solid #DCDFE6;
    }
    .login-page{
        background: #F5F5F5;
    }
    .login-contain .el-form {
        width: 300px;
        margin: 0 auto;
        margin-bottom: 30px;
    }
    .login-contain .el-input-group__append .el-button{
        background: #BC5BA7;
        color: #ffffff;
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
        border: none;
    }
    .login-contain .el-input-group__append .el-button[disabled="disabled"]{
        background: #f5f6f7;
        color: #BC5BA7;
    }
    .login-bg .login-contain .form-input .el-button i {
        line-height: initial;
    }
    /*.login-contain .el-input-group__append.disabled{
        background: #ccc;
        color: #ffffff;
    }*/
    /* 登录背景图 */
    .login-bg{
        width: 1200px;
        height: 860px;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        overflow: hidden;
        margin: 0 auto;
    }
    .login-bg .swiper-container,
    .login-bg .swiper-wrapper,
    .login-bg .swiper-slide{
        height: 100%!important;
        overflow: hidden;
    }
    .login-bg .swiper-slide{
        float: left;
    }
    .login-bg .swiper-img{
        width: 600px;
        height: 860px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
    }
    .login-bg .login-contain{
        background: white;
        width: 600px;
        height: 100%;
        border-radius: 5px;
        padding: 20px;
        box-sizing: border-box;
    }
    .login-bg .login-contain .logo{
        margin: 100px auto 90px;
        width: 320px;
    }
    .login-bg .login-contain .opacity-5{
        opacity: .5;
    }
    .login-bg .login-contain .form-input{
        width: 300px;
        line-height: 50px;
        margin-bottom: 10px;
    }
    .login-bg .login-contain .form-input input{
        height: 50px;
        background: #FAFAFA;
        border: none;
    }
    .login-bg .login-contain .form-input i{
        font-size: 20px;
        line-height: 50px;
        border-radius: 10px;
    }
    .el-input-group__append{
        border: none !important;
    }
    .login-bg .login-contain .form-input .identifying-code{
        width: 112px;
        height: 50px;
        background: #BC5BA7;
        border: none !important;
        border-radius: 0px 10px 10px 0px !important;
        color: #ffffff;
        padding: 0;
    }
    .login-bg .login-contain .forbidden{
        background: #B0D9FF !important;
    }

    .login-contain .login-btn{
        width: 300px;
        height: 54px;
        background: #BC5BA7;
        box-shadow: 0px 2px 6px 0px rgba(45, 123, 181, 0.3);
        border-radius: 10px !important;
        font-size: 20px;
        font-family: Helvetica;
        color: #FFFFFF;
        line-height: 24px;
        border: none;
    }
    .login-bg .login-contain .w-300{
        width: 300px;
        margin: 20px auto 37px;
    }
    .login-bg .login-contain .third-party{
        position: relative;
    }
    .login-bg .login-contain .third-party::after,
    .login-bg .login-contain .third-party::before{
        content: "";
        height: 1px;
        width: 60px;
        background: #000000;
        opacity: 0.14;
        position: absolute;
        top: 50%;
    }
    .login-bg .login-contain .third-party::before{
        left: 0;
    }
    .login-bg .login-contain .third-party::after{
        right: 0;
    }

    .position{
        position: relative;
        background: #ffffff;
    }
    .swiper-pagination{
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
    }

    .my-bullet{
        width: 12px;
        height: 12px;
        background: #ffffff;
        opacity: 0.3;
        user-select: none;
        margin: 0 5px;
        border-radius: 50%;
        display: inline-block;
        cursor: pointer;
    }
    .my-bullet-active{
        opacity: 1;
    }
    .el-message-box .el-button--primary{
        background: #BC5BA7;
        border-color: #BC5BA7;
        border-radius: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue